const VEILLE_RESET = 'VEILLE/RESET';

export default function veilleResetAction () {
  return {
    type: VEILLE_RESET
  };
}

export { VEILLE_RESET };